export const APPOINTMENT = 'appointment'
export const BING = 'bing'
export const CERTIFIED = 'certified'
export const PREMIUM = 'premium'
export const GOOGLE = 'google'
export const GENERAL = 'general'
export const NA = 'N/A'
export const RAYBAN_STORES = 'raybanstores'
export const STORE_LOCATOR_GEOLOCALIZED = 'geolocalized'
export const STORE_LOCATOR_TEXT = 'text'
export const STORIES = 'stories'
export const LENS_SWAP = 'lensswap'
export const APPOINTMENT_BOOKING_SERVICE_NAME = 'commercialbooking'
export const STORE_LOCATOR_DISCOVER_MORE_ABOUT_SERVICE_NAME = 'YEXT'
export const STORE_LOCATOR_BLACK_CLUSTERING_ICON =
  '/rbstatichtml/assets/images/icons/pin_dark_no_rb_logo.svg'
export const STORE_LOCATOR_RED_MAP_CLUSTERING_ICON =
  '/rbstatichtml/assets/images/icons/pin_red_no_rb_logo.svg'
export const EYE_EXAM = 'eyeExam'
